import { Flex, Typography } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';

import { FormTextarea } from '../../../components/FormTextarea/FormTextarea.tsx';
import { ValidationError } from '../../../hooks/validation/types.ts';
import { ReconciliationFormReturn } from '../types.ts';

export const ReconciliationFinalSection = ({
  active,
  form,
  isArvOrder,
  isMockOrder,
  valueTypesSubHeader,
  reconciliationCommentaryError,
  aivReconciliationCommentaryError,
  arvReconciliationCommentaryError,
  highestAndBestUseCommentaryError,
  setSectionRef,
}: {
  active: boolean;
  form: ReconciliationFormReturn;
  isArvOrder: boolean;
  isMockOrder: boolean;
  valueTypesSubHeader: ReactNode;
  reconciliationCommentaryError?: ValidationError;
  aivReconciliationCommentaryError?: ValidationError;
  arvReconciliationCommentaryError?: ValidationError;
  highestAndBestUseCommentaryError?: ValidationError;
  setSectionRef: (el: HTMLDivElement | null) => void;
}) => (
  <Flex
    ref={setSectionRef}
    backgroundColor={active ? 'surface3' : 'surface1'}
    borderRadius="5px"
    padding="12px"
    flexDirection="column"
    gap={4}
  >
    <Typography variant="h1">Final Reconciliation</Typography>
    <Flex flex={1} flexDirection="column">
      {isArvOrder ? (
        <>
          {valueTypesSubHeader}
          <Controller
            name="aivReconciliationCommentary"
            control={form.control}
            render={({ fieldState }) => (
              <FormTextarea
                name="aivReconciliationCommentary"
                requiredFieldName="aivReconciliationCommentary"
                control={form.control}
                label="AIV Reconciliation Commentary"
                placeholder={isMockOrder ? 'Optional' : 'Required'}
                isRequired={!isMockOrder}
                labelWidth="250px"
                inputWidth="500px"
                labelColor="textSecondary"
                labelVariant="h3"
                size="sm"
                resize="vertical"
                height="200px"
                customErrorMessage={
                  fieldState.isTouched ? aivReconciliationCommentaryError?.message : undefined
                }
                column
              />
            )}
          />
          <Controller
            name="arvReconciliationCommentary"
            control={form.control}
            render={({ fieldState }) => (
              <FormTextarea
                name="arvReconciliationCommentary"
                requiredFieldName="arvReconciliationCommentary"
                control={form.control}
                label="ARV Reconciliation Commentary"
                placeholder={isMockOrder ? 'Optional' : 'Required'}
                isRequired={!isMockOrder}
                labelWidth="250px"
                inputWidth="500px"
                labelColor="textSecondary"
                labelVariant="h3"
                size="sm"
                resize="vertical"
                height="200px"
                customErrorMessage={
                  fieldState.isTouched ? arvReconciliationCommentaryError?.message : undefined
                }
                column
              />
            )}
          />
        </>
      ) : (
        <Controller
          name="reconciliationCommentary"
          control={form.control}
          render={({ fieldState }) => (
            <FormTextarea
              name="reconciliationCommentary"
              requiredFieldName="reconciliationCommentary"
              control={form.control}
              label="Reconciliation Commentary"
              placeholder={isMockOrder ? 'Optional' : 'Required'}
              isRequired={!isMockOrder}
              labelWidth="250px"
              inputWidth="500px"
              labelColor="textSecondary"
              labelVariant="h3"
              size="sm"
              resize="vertical"
              height="300px"
              customErrorMessage={
                fieldState.isTouched ? reconciliationCommentaryError?.message : undefined
              }
              column
              subHeaderContent={valueTypesSubHeader}
            />
          )}
        />
      )}
    </Flex>
    <Flex flex={1} flexDirection="column">
      <Controller
        name="highestAndBestUseCommentary"
        control={form.control}
        render={({ fieldState }) => (
          <FormTextarea
            name="highestAndBestUseCommentary"
            requiredFieldName="highestAndBestUseCommentary"
            control={form.control}
            label="Highest & Best Use Commentary"
            placeholder={isMockOrder ? 'Optional' : 'Required'}
            isRequired={!isMockOrder}
            height={isArvOrder ? '200px' : '300px'}
            labelWidth="250px"
            inputWidth="500px"
            labelColor="textSecondary"
            labelVariant="h3"
            size="sm"
            resize="vertical"
            customErrorMessage={
              fieldState.isTouched ? highestAndBestUseCommentaryError?.message : undefined
            }
            column
          />
        )}
      />
    </Flex>
  </Flex>
);
